import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/dreamscape.css';
import './i18n/config'; // Initialize i18n
import App from './App';

// Apply dark theme by default
document.documentElement.classList.add('dark');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
